export default {
    salaryUnit: "VND",
    pleaseSelect: "Please select",
    negotiated: "Negotiated",
    unit: "Million",
    lessThanFiveMillion: "Lower 5 Million",
    moreThanFiftyMillion: "Over 50 Million",
    salaryRangePrefix: "to",
};
